import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { LanguageProvider } from './lib/i18n'
/* El editor de bloques de las entradas del blog. Antes que los estilos del
   panel, como en el editor, para que éstos puedan ajustarlo. */
import '@webbuilder/ui/block-editor.css'
import './styles.css'
import '@webbuilder/ui/sidebar-navigation.css'
import '@webbuilder/ui/brand.css'
import '@webbuilder/ui/loading-mascot.css'
import '@webbuilder/ui/ai-mascot.css'
import '@webbuilder/ui/account-menu.css'
import '@webbuilder/ui/record-fields.css'
import { applyStoredAccent } from '@webbuilder/ui'

/* Antes de montar nada: el atributo tiene que estar puesto en el primer pintado
   o el panel entra en el azul de la casa y salta al color elegido un fotograma
   después. Ver `accent.ts`. */
applyStoredAccent()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Envuelve la aplicación entera, y no cada pantalla: el idioma es de quien
        ha iniciado sesión, así que vale igual en el selector de proyectos, en
        los ajustes de la cuenta y dentro de cualquier proyecto. `RegionProvider`
        va por dentro y por proyecto, que es otra cosa: aquél decide en qué
        moneda se cobra, éste en qué idioma se lee el panel. */}
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </StrictMode>,
)
